// BHP-1038: Tailwind auth layout (login / forgot / register). Rebuilds the
// legacy split auth screen in Tailwind: a dark left panel with the white BizHost
// logo above a white card, and the auth background image on the right (desktop).
import React from 'react';
import authBg from '../../assets/images/auth_bg.jpg';

interface AuthLayoutProps {
  title?: React.ReactNode;
  /** Optional links/actions rendered under the card body (e.g. forgot/register). */
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export default function AuthLayout({
  title,
  footer,
  children
}: AuthLayoutProps): JSX.Element {
  return (
    <div className="flex min-h-screen font-sans text-ink">
      <div className="flex w-full items-center bg-surface-panel px-8 md:w-[440px] md:px-16">
        <div className="w-full max-w-[340px]">
          <h1 className="mb-6 text-2xl font-semibold text-white">BizHost</h1>
          <div className="rounded-lg bg-surface p-6 shadow-lg">
            {title != null ? (
              <p className="mb-4 text-lg font-medium">{title}</p>
            ) : null}
            {children}
            {footer != null ? (
              <div className="mt-6 text-center text-sm text-ink-muted">
                {footer}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div
        className="hidden flex-1 bg-cover bg-center md:block"
        style={{ backgroundImage: `url(${authBg})` }}
        aria-hidden="true"
      />
    </div>
  );
}
